module.exports = __webpack_public_path__ + "media/images/icons/filled/trophy-113ef29a1d6bfa1f0d29e0c4c332873b.svg";